export default __webpack_public_path__ + "static/media/490.df777335.jpg";